import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Payment from './views/Payment.vue'
import PageNotFound from './views/PageNotFound.vue'
import SetupPage from './views/SetupPage.vue'
import SetupProfile from './views/SetupProfile.vue'
import SetupAuth from './views/SetupAuth.vue'
import Contact from './views/Contact.vue'
import Instruction from './views/Instruction.vue'
import Automation from './views/Automation.vue'
import MyAccount from './views/MyAccount.vue'
import Authorize from './views/Authorize.vue'
import SetupAssistant from './views/SetupAssistant.vue'

import store from './store'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    { path: '/home', component: Home, alias: '/' },
    {
      path: '/auth-setup',
      name: 'authSetup',
      component: SetupAuth
    },
    {
      path: '/profile-setup',
      name: 'profileSetup',
      component: SetupProfile
    },
    {
      path: '/page-setup',
      name: 'pageSetup',
      component: SetupPage
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/instructions',
      name: 'instruction',
      component: Instruction
    },
    {
      path: '/automation',
      name: 'automation',
      component: Automation
    },
    {
      path: '/account',
      name: 'account',
      component: MyAccount
    },
    {
      path: '/auth',
      name: 'auth',
      component: Authorize
    },
    {
      path: '/assist',
      name: 'assist',
      component: SetupAssistant
    },
    {
      path: '*',
      name: 'notFound',
      component: PageNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/auth' || to.fullPath === '/c/:id') {
    next()
  } else if (store.state.autorized) {
    next()
  } else {
    axios.get('/api/authorized')
      .then(response => {
        if (response.data === 'authorized') {
          store.dispatch('appLogin')
          next()
        } else {
          if (to.fullPath === '/' || to.fullPath === '/home' ||
            to.fullPath === '/payment' || to.fullPath === '/page-setup' ||
            to.fullPath === '/profile-setup' || to.fullPath === '/auth-setup' ||
            to.fullPath === '/contact' || to.fullPath === '/automation' ||
            to.fullPath === '/account' || to.fullPath === '/assist' ||
            to.fullPath === '/instructions'
          ) {
            next('/auth')
          }
          next()
        }
      })
      .catch(() => {
        next('/auth')
      })
  }
})

export default router
